export const BULK_UPLOAD_STATUS_VIEW: {
  PROCESSING: 1;
  FAILURE: 2;
  SUCCESS: 3;
} = {
  PROCESSING: 1,
  FAILURE: 2,
  SUCCESS: 3,
};

export const BULK_UPLOAD_API_STATUS: {
  PROCESSING: 1;
  PROCESSED: 2;
} = {
  PROCESSING: 1,
  PROCESSED: 2,
};
